module.exports = __webpack_public_path__ + "media/src/images/bookmark-979df102c8a4c4cd2531399e497c585b.png";